
import { showToast } from '/src/v4/toast.js';

// Gallery — load SVG mockups + handle thumbnail switching
import('/src/v4/product-mockups.js').then(({ MOCKUPS, RELATED }) => {
  const main = document.getElementById('gallery-svg');
  const thumbs = document.querySelectorAll('.gallery-thumb');

  function setView(view) {
    main.innerHTML = MOCKUPS[view] || '';
  }
  thumbs.forEach((b) => { b.innerHTML = MOCKUPS[b.dataset.view] || ''; });
  setView('overview');

  document.getElementById('gallery-thumbs').addEventListener('click', (e) => {
    const t = e.target.closest('.gallery-thumb');
    if (!t) return;
    e.stopPropagation();
    thumbs.forEach((b) => b.classList.remove('active'));
    t.classList.add('active');
    setView(t.dataset.view);
  });

  // Related-product thumbs use the smaller RELATED mockups.
  document.querySelectorAll('.related-card .thumb[data-thumb]').forEach((el) => {
    el.innerHTML = RELATED[el.dataset.thumb] || '';
  });
});

// Variant toggles
document.querySelectorAll('.option-values').forEach((group) => {
  group.addEventListener('click', (e) => {
    const v = e.target.closest('.option-value');
    if (!v) return;
    e.stopPropagation();
    group.querySelectorAll('.option-value').forEach((b) => b.classList.remove('active'));
    v.classList.add('active');
  });
});

// Quantity steppers
const qty = document.getElementById('qty');
document.getElementById('qty-dec').addEventListener('click', (e) => { e.stopPropagation(); qty.value = Math.max(1, parseInt(qty.value, 10) - 1); });
document.getElementById('qty-inc').addEventListener('click', (e) => { e.stopPropagation(); qty.value = Math.min(99, parseInt(qty.value, 10) + 1); });

// Tab panels
document.querySelector('.product-tabs').addEventListener('click', (e) => {
  const tab = e.target.closest('.chart-tab');
  if (!tab) return;
  const target = tab.dataset.tab;
  document.querySelectorAll('.product-tab-panel').forEach((p) => {
    p.hidden = p.dataset.panel !== target;
  });
});

// Cart actions
document.getElementById('add-cart').addEventListener('click', (e) => {
  e.stopPropagation();
  showToast(`Added ${qty.value} × AdminLTE Pro to cart`, { variant: 'success' });
});
document.getElementById('buy-now').addEventListener('click', (e) => {
  e.stopPropagation();
  showToast('Redirecting to checkout…', { variant: 'success' });
});
